import { getTenantId } from '../util';
import { createAxiosAuthInstance } from './api';

//dummy auth platform
const axios = createAxiosAuthInstance();

const UI_CATEGORY = 'UICategory';

export async function postLogin(payload) {
  const { username, password } = payload;

  const convertedCredentials = window.btoa(`${username}:${password}`);

  const headers = {
    'Access-Control-Allow-Origin': '*'
  };

  return await axios
    .post(
      `/users/login`,
      { credentials: convertedCredentials, tenantId: getTenantId() },
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        if (err.response.status === 401) {
          throw {
            status: err.response.status,
            error: "Either user doesn't exists or wrong password"
          };
        }

        if (err.response.status === 504) {
          throw {
            status: err.response.status,
            error: 'Your connection has timed out. Please try again later.'
          };
        }

        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function fetchUsersModules(token) {
  const headers = {
    Authorization: token,
    'Access-Control-Allow-Origin': '*'
  };

  return await axios
    .get(`/users/modules`, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function fetchResources(token, applicationId, roleCode) {
  const headers = {
    Authorization: token,
    'Access-Control-Allow-Origin': '*'
  };

  const params = {
    category: UI_CATEGORY,
    applicationId,
    roleCode
  };

  return await axios
    .get(`/resources`, { headers, params })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function putChangePassword(payload) {
  const { username, password, newPassword, userId } = payload;

  const convertedCredentials = window.btoa(`${username}:${password}`);
  const headers = {
    Authorization: `Basic ${convertedCredentials}`
  };

  const apiPayload = {
    newPassword: window.btoa(newPassword),
    oldPassword: window.btoa(password),
    userId
  };

  return await axios
    .put(`/users/changePassword`, apiPayload, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function putChangeDefaultRole(
  token,
  roleCode,
  moduleCode,
  isDefault
) {
  const headers = {
    Authorization: token,
    'Access-Control-Allow-Origin': '*'
  };

  const apiPayload = {
    roleCode,
    moduleCode,
    isDefault
  };

  return await axios
    .put(`/users/default`, apiPayload, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function postLogout({ payload }) {
  const { token } = payload;
  const headers = { 'Access-Control-Allow-Origin': '*' };

  return await axios.delete(`/users/logout?token=${token}`, { headers });
}

export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};
export const getCookie = (name) => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = (name) => {
  document.cookie = name + '=; Max-Age=-99999999;';
};
